import { render } from "./ListError.vue?vue&type=template&id=34a486e1&scoped=true&ts=true"
import script from "./ListError.vue?vue&type=script&lang=ts"
export * from "./ListError.vue?vue&type=script&lang=ts"

import "./ListError.vue?vue&type=style&index=0&id=34a486e1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a486e1"]])

export default __exports__